<div class="broadcast-nudge">
    <div class="snackbar-close">
        <button (click)="dismiss()"> 
            <img class="nudge-close" src="assets/icons/close.svg" /> 
        </button> 
    </div>
    <div class="snackbar-info">
        <img class="nudge-icon" src="{{ data.icon }}"/>
        <p class="nudge-text" [innerHTML]="data.message"></p>
    </div>
    <div class="snackbar-end">
        <p *ngIf="totalMessages > 1" class="pending-messages">
            {{ data.currentNudge }}/{{ totalMessages }} 
        </p>
    </div>
</div>